
























import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { Vector2 } from '@/utilityModels/vector2';

import { ResourceHelper } from '@/helper/resourceHelper';

@Component({
    components: {
    },
})
export default class BoundingBox extends Vue 
{
    // 回転コントローラまでの距離(円のサイズとの相対)
    TO_ROTATE_POINT : number = 27.0 / 12.0;

    @Prop() private layer! : Layer | null;
    @Prop() private scale! : number;
    @Prop() private offsetX! : number;
    @Prop() private offsetY! : number;
    @Prop() private cursorWidth! : number;
    @Prop() private cursorHeight! : number;

    // 選択中のカーソル
    private selectedCursor : string = "none";
    // ドラッグ開始時のマウス座標
    private startX : number = 0;
    private startY : number = 0;
    // ドラッグ開始時のレイヤーの位置・サイズ
    private srcX : number = 0;
    private srcY : number = 0;
    private srcRotate : number = 0;
    private srcWidth : number = 0;
    private srcHeight : number = 0;

    private get isGroup()
    {
        return this.layer != null && this.layer.layerType == "group";
    }

    private get isTextLayer(){
        return this.layer != null &&
        (this.layer.layerType == "plainText" || this.layer.layerType == "simpleText"
        || this.layer.layerType == "circleText" || this.layer.layerType == "d3Text");
    }

    private get pointerEvents(){
        return this.layer != null &&
        (this.layer.layerType == "plainText" || this.layer.layerType == "table" || this.layer.layerType == "simpleText"
        || this.layer.layerType == "circleText" || this.layer.layerType == "d3Text") ? "auto" : "all";
    }

    private get rotateStyle(){
        var fileName = "rotationArrow.png";
        // サイズは目視による
        return { cursor : "-webkit-image-set(url(" + ResourceHelper.getResource(fileName) + ") 5x) 10 11, crosshair" };
    }

    private get cursorGroup1(){
        // 初期位置で左上と右下
        if(this.layer == null){ return; }
        var cursor = "";
        if(this.layer.rotate > -157.5 && this.layer.rotate < -112.5
        || this.layer.rotate > 22.5 && this.layer.rotate < 67.5){ cursor = "ns-resize"; }
        else if(this.layer.rotate >= -112.5 && this.layer.rotate <= -67.5
        || this.layer.rotate >= 67.5 && this.layer.rotate <= 112.5){ cursor = "nesw-resize"; }
        else if(this.layer.rotate > -67.5 && this.layer.rotate < -22.5
        || this.layer.rotate > 112.5 && this.layer.rotate < 157.5){ cursor = "ew-resize"; }
        else{ cursor = "nwse-resize"; }
        return {cursor : cursor};
    }
    private get cursorGroup2(){
        // 初期位置で左下と右上
        if(this.layer == null){ return; }
        var cursor = "";
        if(this.layer.rotate > -157.5 && this.layer.rotate < -112.5
        || this.layer.rotate > 22.5 && this.layer.rotate < 67.5){ cursor = "ew-resize"; }
        else if(this.layer.rotate >= -112.5 && this.layer.rotate <= -67.5
        || this.layer.rotate >= 67.5 && this.layer.rotate <= 112.5){ cursor = "nwse-resize"; }
        else if(this.layer.rotate > -67.5 && this.layer.rotate < -22.5
        || this.layer.rotate > 112.5 && this.layer.rotate < 157.5){ cursor = "ns-resize"; }
        else{ cursor = "nesw-resize"; }
        return {cursor : cursor};
    }
    private get cursorGroup3(){
        // 初期位置で上と下
        if(this.layer == null){ return; }
        var cursor = "";
        if(this.layer.rotate > -157.5 && this.layer.rotate < -112.5
        || this.layer.rotate > 22.5 && this.layer.rotate < 67.5){ cursor = "nesw-resize"; }
        else if(this.layer.rotate >= -112.5 && this.layer.rotate <= -67.5
        || this.layer.rotate >= 67.5 && this.layer.rotate <= 112.5){ cursor = "ew-resize"; }
        else if(this.layer.rotate > -67.5 && this.layer.rotate < -22.5
        || this.layer.rotate > 112.5 && this.layer.rotate < 157.5){ cursor = "nwse-resize"; }
        else{ cursor = "ns-resize"; }
        return {cursor : cursor};
    }
    private get cursorGroup4(){
        // 初期位置で左と右
        if(this.layer == null){ return; }
        var cursor = "";
        if(this.layer.rotate > -157.5 && this.layer.rotate < -112.5
        || this.layer.rotate > 22.5 && this.layer.rotate < 67.5){ cursor = "nwse-resize"; }
        else if(this.layer.rotate >= -112.5 && this.layer.rotate <= -67.5
        || this.layer.rotate >= 67.5 && this.layer.rotate <= 112.5){ cursor = "ns-resize"; }
        else if(this.layer.rotate > -67.5 && this.layer.rotate < -22.5
        || this.layer.rotate > 112.5 && this.layer.rotate < 157.5){ cursor = "nesw-resize"; }
        else{ cursor = "ew-resize"; }
        return {cursor : cursor};
    }

    private get x1() : number { return this.getVertex(0).x; }
    private get y1() : number { return this.getVertex(0).y; }
    private get x2() : number { return this.getVertex(1).x; }
    private get y2() : number { return this.getVertex(1).y; }
    private get x3() : number { return this.getVertex(2).x; }
    private get y3() : number { return this.getVertex(2).y; }
    private get x4() : number { return this.getVertex(3).x; }
    private get y4() : number { return this.getVertex(3).y; }

    private get framePoints()
    {
        var points = "";
        for(var i = 0; i < 4; ++i)
        {
            var vertex = this.getVertex(i);
            points += vertex.x + "," + vertex.y;
            if(i < 3) { points += " "; }
        }
        return points;
    }

    private get lx() : number { return (this.x1 + this.x2) / 2; }
    private get ly() : number { return (this.y1 + this.y2) / 2; }
    private get tx() : number { return (this.x1 + this.x4) / 2; }
    private get ty() : number { return (this.y1 + this.y4) / 2; }
    private get rx() : number { return (this.x3 + this.x4) / 2; }
    private get ry() : number { return (this.y3 + this.y4) / 2; }
    private get bx() : number { return (this.x2 + this.x3) / 2; }
    private get by() : number { return (this.y2 + this.y3) / 2; }

    private get rotateX() : number 
    {
        if (this.layer == null) { return 0; }
        var cursorWidth = (this.layer.height < 0) ? -this.cursorWidth : this.cursorWidth;
        return this.tx + this.TO_ROTATE_POINT * cursorWidth * Math.sin(this.layer.rotate * Math.PI / 180); 
    }
    private get rotateY() : number 
    { 
        if (this.layer == null) { return 0; }
        var cursorHeight = (this.layer.height < 0) ? -this.cursorHeight : this.cursorHeight;
        return this.ty - this.TO_ROTATE_POINT * cursorHeight * Math.cos(this.layer.rotate * Math.PI / 180); 
    }

    private getVertex(index : number) : Vector2
    {
        if(this.layer == null) { return new Vector2(); }
        var vertexes = this.layer.getVertexes();
        var vertex = vertexes[index];
        return new Vector2(vertex.x * this.scale + this.offsetX, vertex.y * this.scale + this.offsetY);
    }

    private get r()
    {
        return this.cursorWidth / 2;
    }

    private selectCursor(event : MouseEvent, cursor : string)
    {
        // カーソル選択イベント通知
        this.$emit("cursorSelected", cursor);
    }

    private selectFrame(event)
    {
        // フレーム選択イベント通知
        this.$emit("frameSelected");
    }
}
